import { ServiceCalls } from '../serviceCalls';

export const messages = {
  tooLarge: `It looks like you need to order a Data Snapshot for an area more than 100,000,000 sqm or containing more the 300 freehold titles. That's not a problem, however we'll need to break your order down.<p/> 
  <ul style="list-style-type: disc; padding-left:20px"><li>You can break your search polygon down into multiple areas and order more than one Data Snapshot. Or</li>
  <li>You can reduce your search polygon to a smaller area and order one Data Snapshot.</li></ul>
  <p>To achieve one of the above, use the edit/select tool to remove and re-mark your polygons, then select 'order Data Snapshot' and 'use exiting polygon'</p>
  <p>If you get stuck, just give us a call on 0800 240 47 46</p>`,
  multi: `It looks like you need to order a Data Snapshot for more than one polygon. That's not a problem, however the polygons need to be joined together for you to proceed.<p/>
 You can use the edit/select tool to delete your current polygons and draw a new one for the whole area.</p>
 If you get stuck, just give us a call on 0800 240 47 46`,
  dataError:
    '<p>Unfortunately it is not possible to purchase a Data Snapshot for the search area.  Please contact the Support Team on 0800 240 4746 and relay this message.</p>',
  snapshotLimit:
    '<p>The intersecting titles in your search have exceeded our limit.</p><p>Please call our support team on 0800 240 47 46 and they will help you with a bespoke Data Snapshot request.</p>',
  orderLimit:
    '<p>The intersecting titles in your search have exceeded our limit.</p><p>Please call our support team on 0800 240 47 46 and they will help you with your enquiry.</p>',
  progressError:
    'Unfortunately there has been a problem processing the order.  Please contact the Customer Support Team on 0800 240 4746',
  crossoverError:
    'Unfortunately, there is an error with your current polygon. The green circle highlights where the error is in the polygon.<p />Please use the Select/Edit tool to edit the polygon. Drag the nodes to remove any crossed over lines, as these invalidate the polygon.<p />For further assistance please call the Support Team on 0800 240 4746.',
  crossoverError2:
    'Unfortunately, there is an error with one or more of your selected polygons. The green circle highlights where the error is in the polygon.<p />Please use the Select/Edit tool to edit the polygon. Drag the nodes to remove any crossed over lines, as these invalidate the polygon.<p />For further assistance please call the Support Team on 0800 240 4746.',
  polygonError:
    'Unfortunately, there’s an error with one or more of your selected polygons. You can upload a plan of the search boundary via ‘use my own plan’ and our support team will process your order manually.<p />For further assistance please call the Support Team on 0800 240 4746.',
  boundaryError: 'Please select the polygon(s) that represent the area required for the searches',
  orderTooLarge:
    'Unfortunately, the search boundary is too large.  You can upload a plan of the search boundary via ‘use my own plan’ and our support team will process your order manually.<p />For further assistance please call the Support Team on 0800 240 4746.',
  unregistered:
    '<p>This may be unregistered land</p><p>Use the Draw Polygon tool to select the area required for your search</p><p>Contact the Support Team for further assistance on<br/>0800 240 47 46</p>',
  hmlrError:
    'Unfortunately, there’s an error with the HMLR polygons. You can upload a plan of the search boundary via ‘use my own plan’ and our support team will process your order manually.<p />For further assistance please call the Support Team on 0800 240 4746.',
  holes: 'Boundary contains holes',
  noSearch:
    'No titles could be found that matched your search parameters. Please check the title number(s) are correct.',
};
export const sortByKey = (array, key) => {
  array.sort(function (a, b) {
    var x = a.search_result[key];
    var y = b.search_result[key];
    if (!x) x = '9999';
    if (!y) y = '9999';
    return Date.parse(x) - Date.parse(y);
  });
  return array;
};

export const b64toBlob = (b64Data, contentType, sliceSize) => {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const saveB64 = (data, filename) => {
  const blob = b64toBlob(data);
  const blobUrl = URL.createObjectURL(blob);
  let link = document.createElement('a');
  link.setAttribute('href', blobUrl);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const clearTempMarkup = tempMarkup => {
  tempMarkup.destroyFeatures();
  tempMarkup.redraw();
};
export const addTempMarkup = ({ feature, styles, ol }) => {
  var col;
  $('.saved-poly').removeClass('orangeBG');
  if (feature) {
    if (feature.attributes.title_no) {
      $('.saved-poly').each(function (i, obj) {
        if ($(obj).data('lrtitle') === feature.attributes.title_no) {
          $(obj).addClass('orangeBG');
        }
      });
    }
    if (feature.attributes.class_of_title.indexOf('leasehold') > -1) {
      col = '#0000ff';
    } else if (feature.attributes.class_of_title.indexOf('freehold') > -1) {
      col = '#e00000';
    } else {
      col = '#000000';
    }
    var newStyle = {};
    jQuery.extend(newStyle, styles.defaultStyle);
    newStyle.strokeColor = col;
    newStyle.strokeWidth = 2;
    newStyle.fillColor = col;
    newStyle.fillOpacity = 0.2;
    var highlight = new OpenLayers.Feature.Vector(feature.geometry.clone(), null, newStyle);
    ol.layers.tempMarkup.addFeatures([highlight]);
    ol.layers.tempMarkup.redraw();
  }
};
export const getAddress = uprn => {
  if (uprn.split(',').length == 1) {
    ServiceCalls.callService('getAddress', {
      uprn: uprn,
    });
  }
};
export const setCursor = ({ type }) => {
  const state = window.state;
  if (type === 'progress' && $('body').css('cursor') !== 'progress') {
    state.currentCursor = $('body').css('cursor');
  }
  if (type === 'progress' || !state.siteBusy) {
    $('*').css('cursor', type, 'important');
    $('.navbar *, .sidebar *, .toolbar *').css('cursor', 'default', 'important');
    $('a').css('cursor', 'pointer', 'important');
  }
};
export const hasSeen = ({ item }) => {
  const state = window.state;
  for (var i = 0; i < state.seenItems.length; i++) {
    if (state.seenItems[i].gss_code === item.gss_code && state.seenItems[i].ref.toString() === item.ref.toString()) {
      return true;
    }
  }
  return false;
};
export const logPlanningView = ({ item, settings }) => {
  const state = window.state;
  ServiceCalls.callService('logPlanningView', {
    guid: guid,
    xy: '(' + state.planningCenter.x + ',' + state.planningCenter.y + ')',
  });
  var url =
    settings.baseURL +
    '/account/log-planning-location-usage?end_user=' +
    guid +
    '&gss_code=' +
    item.gss_code +
    '&ref=' +
    item.ref.toString();
  $.ajax({
    url: url,
    type: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    success: function () {},
    error: function (error) {
      console.log(error.responseJSON.message);
    },
  });
};
export const showArea = feat => {
  var area = feat.geometry.getArea().toFixed(2);
  var acres = (area * 0.000247105).toFixed(2);
  $('#output').html('Area: ' + area + 'm<sup>2</sup> (' + acres + ' acres)');
};
export const showSection = type => {
  $('.extra-content, #info-panel .content, #info-panel .header').hide();
  $('.' + type + '-content').show();
};
export const hideSection = type => {
  $('.' + type + '-content').hide();
  $('#info-panel .content, #info-panel .header').show();
};
export const removeDuplicates = str => {
  var json = JSON.parse(str);
  var oldItem = null;
  var arr = [];
  var newJson = [];
  var outJson = [];
  var dump = [];
  if (!Array.isArray(json[0])) arr = [json];
  else arr = json;
  arr.forEach(function (arrItem) {
    arrItem.forEach(function (item) {
      if (oldItem && item.x.toFixed(2) == oldItem.x.toFixed(2) && item.y.toFixed(2) == oldItem.x.toFixed(2)) {
        dump.push(item);
      } else {
        newJson.push({ x: item.x.toFixed(2), y: item.y.toFixed(2) });
      }
    });
    if (newJson[0].x !== newJson[newJson.length - 1].x && newJson[0].y !== newJson[newJson.length - 1].y) {
      newJson.push(Object.assign({}, newJson[0]));
    }
    outJson.push(newJson);
    newJson = [];
  });
  return { json: JSON.stringify(outJson), dump: JSON.stringify(dump) };
};
export function showError({ title, message, callback }) {
  const state = window.state;
  $('#error-message .title').html(title);
  $('#error-message .message').html(message);
  $('#error-message .ok')
    .off()
    .click(function () {
      if (state.currentCursor) setCursor({ type: state.currentCursor });
      $('#error-message').hide();
      $('#blocker').hide();
      if (callback) {
        callback();
      }
    });
  $('#blocker').show();
  $('#error-message').show();
  window.showError = showError;
}
export const distanceBetween = (geom1, geom2) => {
  const distance = geom1.distanceTo(geom2, { details: true });
  return distance;
};
